"use client";

import DeletePopover from "@/app/shared/delete-popover";
import PencilIcon from "@/components/icons/pencil";
import { HeaderCell } from "@/components/ui/table";
import { IPlace } from "@/utilities/types/Places";
import { ActionIcon, Tooltip } from "rizzui";

type Columns = {
  data: IPlace[];
  onDeleteItem: (id: string) => Promise<void>;
  onEditItem: (row: IPlace) => void;
};

export const getColumns = ({ onDeleteItem, onEditItem }: Columns) => [
  {
    title: (
      <HeaderCell
        title="Name"
        align="center"
      />
    ),
    key: "name",
    dataIndex: "name",
    align: "center",
  },
  {
    title: (
      <HeaderCell
        title="Category"
        align="center"
      />
    ),
    dataIndex: "category",
    key: "category",
    align: "center",
    render: (value: string | null) => {
      return value || "-";
    },
  },
  {
    title: (
      <HeaderCell
        title="Latitude"
        align="center"
      />
    ),
    dataIndex: "latitude",
    key: "latitude",
    align: "center",
  },
  {
    title: (
      <HeaderCell
        title="Longitude"
        align="center"
      />
    ),
    dataIndex: "longitude",
    key: "longitude",
    align: "center",
  },
  {
    title: (
      <HeaderCell
        className="ps-3"
        title={<span className="whitespace-nowrap">Actions</span>}
        align="center"
      />
    ),
    dataIndex: "action",
    key: "action",
    width: 120,
    render: (_: string, row: IPlace) => (
      <div className="flex items-center justify-end gap-3 pe-4">
        <Tooltip
          size="sm"
          content={"Edit Place"}
          placement="top"
          color="invert"
        >
          <ActionIcon
            size="sm"
            variant="outline"
            onClick={() => onEditItem(row)}
          >
            <PencilIcon className="h-4 w-4" />
          </ActionIcon>
        </Tooltip>
        <DeletePopover
          title={`Delete place`}
          description={`Are you sure you want to delete this place?`}
          onDelete={async () => await onDeleteItem(row.id)}
        />
      </div>
    ),
  },
];
